export const isFileExtensionValid = (fileName: string, extensions: string[]) => {
  const arr = fileName.split('.');
  const ext = arr.length > 0 ? arr[arr.length - 1].toLowerCase() : '';

  return extensions.some(e => e === ext);
};
